import React from 'react';
import * as Styles from 'pages/member/wh/WH.style';
import { useTranslation } from 'react-i18next';
import Checkbox from 'components/common/radio-button';
import ConditionalFragment from 'components/conditional-fragment';
import {
  domainTabs,
  initialValue,
  initialValueOfTransferDomain,
  validationSchema,
  validationSchemaOfTransferDomain,
  whCreateInitialValue,
} from 'constants/wh';
import { CustomHook } from 'utils/custom-hook';
import { Formik } from 'formik';
import FormikErrorMessage from 'components/formik-error-message';
import { DOMAIN_LOOKUP } from '../queries';
import { useMutation } from 'react-query';
import WHDomainForm from 'components/wh/create/WHDomainForm';
import { H6 } from 'components/reusable-css';
import Heading from 'components/Heading/Heading';
import { NewStepDescription } from 'assets/css/common-styles';
import WhAlreadyDomain from 'components/wh/create/WhAlreadyDomain';

const WHStep1 = ({ formikProp }) => {
  const { mutate: domainLookUp, isLoading: domainLookUploading, reset } = useMutation(DOMAIN_LOOKUP);
  const { t } = useTranslation();
  const { mutationProps } = CustomHook();
  const { setFieldValue, values: parentValues } = formikProp;
  const isChecked = parentValues.domain_checked;
  const setIsChecked = (value) => {
    setFieldValue('domain_checked', value);
  };

  // SUBMITTING DOMAIN LOOKUP
  const handleSubmit = (values) => {
    setFieldValue('result', {});
    domainLookUp(
      { domain: values.new_domain },
      mutationProps(() => {}, {
        onSuccess: async (res) => {
          const domainData = res.data || {};
          setFieldValue('result', domainData);
          if (domainData?.available) {
            setFieldValue('domain', domainData.domain);
            setFieldValue('prices.domain', domainData.price);
            setFieldValue('prices.yearly.domain', domainData.price);
          } else {
            setFieldValue('domain', '');
            setFieldValue('prices.domain', 0);
            setFieldValue('prices.yearly.domain', 0);
          }
        },
        onError() {
          setFieldValue('result', {});
          setFieldValue('domain', '');
          setFieldValue('prices.domain', 0);
          setFieldValue('prices.yearly.domain', 0);
        },
      }),
    );
  };

  return (
    <Styles.WHStep1SC id="ST1">
      <Heading name={'wh/create.step1_string1'}>
        <NewStepDescription />
        <Styles.Margin>
          <Styles.FlexContainer onClick={() => setIsChecked(domainTabs.register_a_new_domain)}>
            <Checkbox
              checkbox={isChecked}
              setCheckedValue={() => {
                setIsChecked(domainTabs.register_a_new_domain);
              }}
              data={{ id: domainTabs.register_a_new_domain }}
            />
            <H6>{t('wh/create.step1_string2')}</H6>
          </Styles.FlexContainer>
          <ConditionalFragment condition={isChecked == domainTabs.register_a_new_domain}>
            <Styles.NoNeedDomain>
              <Formik initialValues={initialValue} validationSchema={validationSchema} onSubmit={handleSubmit}>
                {(formikProp) => (
                  <WHDomainForm
                    formikProp={formikProp}
                    domainLookUploading={domainLookUploading}
                    parentValues={parentValues}
                  />
                )}
              </Formik>
            </Styles.NoNeedDomain>
          </ConditionalFragment>
          <Styles.FlexContainer
            onClick={() => {
              setFieldValue('domain', '');
              setFieldValue('price', whCreateInitialValue.prices);
              setIsChecked(domainTabs.transfer_an_existing_domain);
              reset();
            }}
          >
            <Checkbox
              checkbox={isChecked}
              setCheckedValue={() => {
                setIsChecked(domainTabs.transfer_an_existing_domain);
                setFieldValue('domain', '');
              }}
              data={{ id: domainTabs.transfer_an_existing_domain }}
            />
            <H6>{t('wh/create.step1_string6')}</H6>
          </Styles.FlexContainer>
          <ConditionalFragment condition={isChecked == domainTabs.transfer_an_existing_domain}>
            <Formik initialValues={initialValueOfTransferDomain} validationSchema={validationSchemaOfTransferDomain}>
              {(formikProp) => (
                <WhAlreadyDomain formikProp={formikProp} setParentFieldValue={(e) => setFieldValue('domain', e)} />
              )}
            </Formik>
          </ConditionalFragment>
          {/* <Styles.FlexContainer onClick={() => setIsChecked(domainTabs.no_need_for_a_domain)}>
            <Checkbox
              checkbox={isChecked}
              setCheckedValue={() => {
                setIsChecked(domainTabs.no_need_for_a_domain);
              }}
              data={{ id: domainTabs.no_need_for_a_domain }}
            />
            <H6>{t('wh/create.step1_string7')}</H6>
          </Styles.FlexContainer> */}
          {/* <ConditionalFragment condition={isChecked == domainTabs.no_need_for_a_domain}>
            <Styles.NoNeedDomain>
              <P>
                We will assign you a subdomain of <span>*.serverpoint.app.</span> You may change this later or add your
                own domains.
              </P>
            </Styles.NoNeedDomain>
          </ConditionalFragment> */}
        </Styles.Margin>
        <FormikErrorMessage formikProp={formikProp} value="domain" />
      </Heading>
    </Styles.WHStep1SC>
  );
};
export default WHStep1;
